export default {
  buildingComplexes: [],
};
